import React from 'react';
import { ChannelsText, Color1Span, DateDiv, Divider, LeftChild, RightChild, Span1, Span2, StyledContainer, SubMainComponent, TopicADiv, TwitterText } from './ViewCompetitive.styled';
import HeaderSubDiv from './HeaderSubDiv';

const CompetitiveHeader = ({ compData ,shared=false}) => {
    return (

        <SubMainComponent shared={shared} >
            <HeaderSubDiv
                compData={compData?.[0] || {}}
                shared={shared}
                topic1={true}
            />
            <Divider />

            <HeaderSubDiv
                compData={compData?.[1] || {}}
                shared={shared}
                topic1={false}
            />
        </SubMainComponent>
    );
};


export default CompetitiveHeader;